export const segmentProps = {
  remainingCards:"Remaining Cards",
  enrollLaterCards: "Enroll Later Cards",
  spareCards: "Spare Cards",
  assigned: "Assigned Cards",
  firstName:"First Name",
  lastName:"Last Name",
  zip:"Zip",
  totalCards:"Total Cards",
}

export const SLASH_INITIAL_REMOVE_REGEX = /^\/+|\/+$/g
